import './sass/main.scss';
import './plugins/zxingWasm';

import { createApp, h } from 'vue';
import moment from 'moment';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import Signup from './Signup.vue';
import VueGoogleMaps from '@fawmi/vue-google-maps';

import router from './router';
import { routerRef } from './routerHolder';
import store from './store';

import axios from './api/setupAxios';
import $api from './api';
import apiPlugin from './plugins/api';
import vPhoneInput from './plugins/vPhoneInput';

import Icon from '@/components/icons/index.vue';
import ModuleRenderer from '@/components/modules/moduleRenderer/index.vue';

// import Affix from 'vue-affix';
import VueAwesomeCountdown from 'vue-awesome-countdown';

import * as Sentry from '@sentry/vue';

import { getLocalDate } from './helpers';

/* ---------------------------------------------------
 * App selection (App vs Signup)
 * --------------------------------------------------- */
const vueComponentData = window.vueComponentData || {};
const RootComponent = window.location.pathname.endsWith('signup')
  ? Signup
  : App;


const rootProps = vueComponentData.props || {};

/* ---------------------------------------------------
 * Create app
 * --------------------------------------------------- */
const app = createApp({
  render: () => h(RootComponent, rootProps),
});

/* ---------------------------------------------------
 * Global properties
 * --------------------------------------------------- */
app.config.globalProperties.$moment = moment;
app.config.globalProperties.$getLocalDate = getLocalDate;
app.config.globalProperties.$publicMapKey = window.publicMapKey;

/* ===============================
   Extract token FIRST
=============================== */
const urlParams = new URLSearchParams(window.location.search)
window.token = urlParams.get('t')

/* ---------------------------------------------------
 * Global components
 * --------------------------------------------------- */
app.component('icon', Icon);
app.component('module-renderer', ModuleRenderer);

/* ---------------------------------------------------
 * Plugins
 * --------------------------------------------------- */
app.use(router);
app.use(store);
app.use(vuetify);
app.use(apiPlugin);
app.use(vPhoneInput);
const mapKey = window.publicMapKey || '';
if (!mapKey && import.meta.env.DEV) {
  console.warn(
    '[VenueMap] Google Maps API key missing. Set GOOGLE_MAPS_PUBLIC_API_KEY in Laravel .env (config: services.google_maps_account.public_api_key).'
  );
}
app.use(VueGoogleMaps, {
  load: {
    key: mapKey,
    libraries: 'places',
  },
});
// app.use(Affix);
app.use(VueAwesomeCountdown, 'vac');

/* ---------------------------------------------------
 * Sentry
 * --------------------------------------------------- */
const isDev = import.meta.env.DEV;
const forceSentryInit = false;

if (!isDev || forceSentryInit) {
  Sentry.init({
    app,
    dsn: 'https://34758f5898cb3a6720e324e01b749448@o916304.ingest.us.sentry.io/4511061239988224',
    ignoreErrors: [
      'ResizeObserver loop completed with undelivered notifications',
    ],
    integrations: [
      Sentry.browserTracingIntegration({ router }),
    ],
    logErrors: !isDev,
    attachProps: true,
    attachStacktrace: true,
    tracesSampleRate:
      parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE) || 1,
  });
}

/* ---------------------------------------------------
 * nl2br helper (Vue 2 filter replacement)
 * --------------------------------------------------- */
app.config.globalProperties.$nl2br = (str) => {
  if (typeof str !== 'string') return str;

  // Instead of <br /> we're going to use a block displayed empty span with
  // role none for screen readers
  const p =
    '<span class="d-block" role="none" style="height: 1em;"></span>';
  const br =
    '<span class="d-block" role="none" style="height: 0;"></span>';

  const multipleReplaced = str.replace(/\n{2,}/g, p);
  return multipleReplaced.replace(/\n/g, br);
};

/* ---------------------------------------------------
 * Store - Router reference
 * --------------------------------------------------- */
store.$router = router;
routerRef.current = router;

/* ---------------------------------------------------
 * Mount
 * --------------------------------------------------- */
app.mount('#app');

